<template>
    <modal-component 
        :title="$helpers.trans('auth.profileModalTitle')" 
        :open="open" 
        @close="$emit('update:open', false)">

        <form-component 
            ref="form"
            name="Login" 
            action="/profile" 
            :append="{ id: $user.id }"
            @success="profileSaved($event)"
            :spam-filter="false">

            <div class="form-group">
                <label class="control-label">{{ $helpers.trans('auth.email') }}</label>
                <input type="email" required class="form-control" name="email" v-model="user.email">
                <div class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <label class="control-label">{{ $helpers.trans('auth.password') }}</label>
                <input type="password" class="form-control" name="password" v-model="user.password">
                <div class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <label class="control-label">{{ $helpers.trans('auth.passwordConfirmation') }}</label>
                <input type="password" class="form-control" name="password_confirmation" v-model="user.password_confirmation">
                <div class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <label class="control-label">{{ $helpers.trans('auth.firstname') }}</label>
                <input type="text" required class="form-control" name="firstname" v-model="user.firstname">
                <div class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <label class="control-label">{{ $helpers.trans('auth.lastname') }}</label>
                <input type="text" required class="form-control" name="lastname" v-model="user.lastname">
                <div class="invalid-feedback"></div>
            </div>

        </form-component>
    </modal-component>
</template>
<script>
import ModalComponent from '#app#/components/common/Modal.vue'
import FormComponent from '#app#/components/common/Form.vue'

export default {
    components: {
        ModalComponent,
        FormComponent
    },
    props: ['open'],
    data() {
        return {
            user: {
                email: this.$user.email,
                password: null,
                password_confirmation: null,
                firstname: this.$user.firstname,
                lastname: this.$user.lastname,
            },
        }
    },

    methods: {
        profileSaved(event) {
            if(event.status == 200) {
                setTimeout(() => this.$emit('update:open', false), 500);
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// ../default-js/js/components/package/RF/Member/modals/Profile.vue